<template>
  <div
    v-if="showConnectEldInModal == false"
    class="relative overflow-hidden rounded-lg bg-white sm:min-w-120"
  >
    <div class="relative h-full overflow-scroll">
      <!-- Content -->
      <div class="sticky top-0 z-50 rounded bg-white">
        <div class="bg-dark-blue p-4">
          <svg
            class="absolute right-5 top-5 h-4 w-4 cursor-pointer text-light-gray hover:text-white"
            viewBox="0 0 15 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            @click="handleCloseModal()"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M7.42481 5.30349L2.12132 0L0 2.12132L5.30349 7.42481L0.000383496 12.7279L2.1217 14.8492L7.42481 9.54613L12.7279 14.8492L14.8492 12.7279L9.54613 7.42481L14.8496 2.12132L12.7283 0L7.42481 5.30349Z"
              fill="currentColor"
            />
          </svg>
          <!-- <img @click="handleCloseModal()" class="absolute right-6 top-6 h-4 w-4 cursor-pointer"
                            src="@/assets/close-icon.svg" alt="close icon" /> -->
          <!-- <h3 class="text-2xl text-left text-dark-gray bg-white p-6 pb-4">Select Your ELD Provider</h3> -->
          <div class="flex w-full items-center justify-center py-0.5">
            <img
              class="h-5 w-auto"
              src="@/assets/highway_logo.svg"
              alt="highway logo"
            />
          </div>
        </div>
        <div
          class="mt-4 flex w-full items-center justify-start px-6 pb-6 md:mb-2"
        >
          <div class="relative w-full">
            <input
              ref="searchText"
              v-model="searchText"
              type="text"
              placeholder="Search ELD Providers..."
              class="w-full rounded border border-transparent bg-off-white p-4 text-sm hover:border-placeholder-gray focus:bg-white focus:text-dark-gray"
              style="padding-left: 40px; padding-right: 40px"
            />
            <div
              class="absolute left-3 top-0 flex h-full items-center justify-center"
            >
              <div class="cursor-pointer text-gray-over-dark">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  class="h-6 w-6"
                >
                  <path
                    fill-rule="evenodd"
                    d="M10.5 3.75a6.75 6.75 0 100 13.5 6.75 6.75 0 000-13.5zM2.25 10.5a8.25 8.25 0 1114.59 5.28l4.69 4.69a.75.75 0 11-1.06 1.06l-4.69-4.69A8.25 8.25 0 012.25 10.5z"
                    clip-rule="evenodd"
                  />
                </svg>
              </div>
            </div>
            <div
              class="absolute right-3 top-0 flex h-full items-center justify-center"
            >
              <div
                v-if="searchText?.length > 0"
                class="cursor-pointer text-gray-over-dark"
                @click="searchText = ''"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  class="h-6 w-6"
                >
                  <path
                    fill-rule="evenodd"
                    d="M5.47 5.47a.75.75 0 011.06 0L12 10.94l5.47-5.47a.75.75 0 111.06 1.06L13.06 12l5.47 5.47a.75.75 0 11-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 01-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 010-1.06z"
                    clip-rule="evenodd"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="flex flex-col">
        <div class="eld-grid-area mb-8 min-h-50 overflow-scroll px-6">
          <div
            v-if="!isLoading"
            class="grid grid-cols-2 gap-4"
          >
            <round-radio-button-eld
              v-for="item in eldProvidersFilteredAndLimited"
              :key="`eld-${item?.id}`"
              :item="item"
              :handle-click="($event) => handleSelectRadio($event, item?.id)"
              name="eld_provider"
              :value="item?.id"
              :show="true"
              :checked="selectedItem == item?.id"
              :search-text="searchText"
              :constrain-width="true"
            />
            <div
              v-if="additionalELDs > 0"
              class="rrbv-wrapper flex flex-col items-center justify-center rounded-md p-0"
            >
              <span v-if="additionalELDs > 1">
                {{ additionalELDs }} more ELDs
              </span>
              <span v-else>{{ additionalELDs }} more ELD</span>
            </div>
            <div
              v-if="eldProvidersFiltered == 0"
              class="col-span-2 flex h-25 items-center justify-center rounded-lg bg-off-white text-body-color"
            >
              <p class="text-sm">No matching ELD providers found</p>
            </div>
          </div>
          <div
            v-else
            class="mb-8 grid grid-cols-2 gap-4"
          >
            <div
              v-for="index in 10"
              :key="`loading-eld-${index}`"
              class="loading-gradient flex h-20 flex-col items-center justify-center rounded-md border border-light-gray p-0"
            />
          </div>
        </div>
        <div class="z-30 w-full border-t border-light-gray bg-white p-6">
          <button-main
            ref="continuebtn"
            class="focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:ring-offset-2"
            :class="[showELDExemptButton ? 'mb-4' : 'mb-0']"
            :disabled="!selectedItem"
            @click="handleSubmit"
          >
            Continue
          </button-main>
          <button-main
            v-if="showELDExemptButton"
            class="mb-4"
            variant="secondary"
            @click="handleExempt"
          >
            <div class="text-center text-xs sm:text-sm">
              I'm not legally required to have an ELD
            </div>
          </button-main>
        </div>
      </div>
    </div>
  </div>
  <div
    v-else
    class="relative h-95vh overflow-scroll rounded-lg bg-alt-white sm:h-auto sm:max-h-85vh sm:min-w-120"
  >
    <div
      class="sticky top-0 z-50 flex items-center justify-between rounded-t-lg bg-dark-blue p-4"
    >
      <div class="w-5 flex-shrink-0">
        <svg
          class="cursor-pointer text-light-gray hover:text-white"
          viewBox="0 0 19 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          @click="showConnectEldInModal = false"
        >
          <path
            d="M11 2L3 10L11 18"
            stroke="currentColor"
            stroke-width="3"
          />
          <path
            d="M4 10L19 10"
            stroke="currentColor"
            stroke-width="3"
          />
        </svg>
      </div>
      <!-- <h3 v-if="latest_carrier_eld_provider?.connect_channel?.eld_type && latest_carrier_eld_provider?.connect_channel?.eld_type == 'eld_exempt'"
                    class="text-2xl text-left text-dark-gray bg-white p-6 pb-4">Equipment Verification</h3> -->
      <!-- <h3 v-else class="text-2xl text-left text-dark-gray bg-white p-6 pb-4">Connect your ELD to Highway</h3> -->
      <div class="flex w-full items-center justify-center bg-dark-blue py-0.5">
        <img
          class="h-5 w-auto"
          src="@/assets/highway_logo.svg"
          alt="highway logo"
        />
      </div>
      <div class="w-5 flex-shrink-0">
        <svg
          class="h-4 w-4 cursor-pointer text-light-gray hover:text-white"
          viewBox="0 0 15 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          @click="handleCloseModal()"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M7.42481 5.30349L2.12132 0L0 2.12132L5.30349 7.42481L0.000383496 12.7279L2.1217 14.8492L7.42481 9.54613L12.7279 14.8492L14.8492 12.7279L9.54613 7.42481L14.8496 2.12132L12.7283 0L7.42481 5.30349Z"
            fill="currentColor"
          />
        </svg>
      </div>
    </div>
    <div>
      <connect-eld-in-modal
        @close="handleCloseModal()"
        @back="showConnectEldInModal = false"
      />
    </div>
  </div>
</template>

<script>
import ButtonMain from '@/components/Button.vue';
import RoundRadioButtonEld from '@/components/RoundRadioButtonEld.vue';
import ConnectEldInModal from '@/components/ConnectEldInModal.vue';

export default {
  name: 'CarrierPortalELDProviderModal',
  components: {
    ButtonMain,
    RoundRadioButtonEld,
    ConnectEldInModal,
  },
  props: {
    initiallyShowConnectEldInModal: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['click-outside-modal'],
  data() {
    return {
      searchText: '',
      selectedItem: '',
      showConnectEldInModal: false,
    };
  },
  computed: {
    isLoading() {
      return this.$store.state.onboardingPacket?.isEldProvidersLoading;
    },
    updateEld() {
      return this.$store.state.integrations?.updateEld;
    },
    showELDExemptButton() {
      // Not applicable in Carrier Portal for now
      // if (process.env.HIDE_ELD_EXEMPT_BUTTON_IN_CARRIER_PORTAL > 0) {
      //     return false;
      // }
      // return true;
      return false;
    },
    eldProviders() {
      return this.$store.state.onboardingPacket?.eld_providers.filter(
        (el) => el?.eld_type !== 'eld_exempt'
      );
    },
    eldProvidersFiltered() {
      let filtered = this.eldProviders;
      if (this.searchText.length > 0) {
        let regex = new RegExp(this.searchText, 'i');
        filtered = this.eldProviders.filter((eldProvider) =>
          regex.test(eldProvider.name)
        );
      }
      return filtered;
    },
    eldProvidersFilteredAndLimited() {
      return this.eldProvidersFiltered?.slice(0, 7);
    },
    additionalELDs() {
      return (
        this.eldProvidersFiltered.length -
        this.eldProvidersFilteredAndLimited.length
      );
    },
    eldProviderNames() {
      return this.eldProviders.map((el) => el?.name);
    },
    searchResultCount() {
      return this.eldProvidersFiltered.length;
    },
    eldExempt() {
      if (
        this.$store.state.onboardingPacket?.eld_providers?.length > 0 &&
        this.showELDExemptButton
      ) {
        return this.$store.state.onboardingPacket?.eld_providers?.find(
          (el) => el?.eld_type === 'eld_exempt'
        );
      }
      return null;
    },
    latest_carrier_eld_provider() {
      if (this.$store.state.onboardingPacket?.latest_carrier_eld_provider) {
        return this.$store.state.onboardingPacket?.latest_carrier_eld_provider;
      } else if (
        this.$store.state.carriers?.carrierData?.latest_carrier_eld_provider
      ) {
        return this.$store.state.carriers?.carrierData
          ?.latest_carrier_eld_provider;
      }
      return null;
    },
    // availableElds(){
    //     return this.$store.state.integrations?.truckerTools?.availableElds;
    // },
    // channelId(){
    //     return this.$store.state.integrations?.truckerTools?.channelId;
    // },
  },
  watch: {
    latest_carrier_eld_provider: {
      handler(val) {
        let self = this;
        if (val?.connect_channel?.id > 0 && self.selectedItem === '') {
          self.selectedItem = val?.connect_channel?.id;
        }
      },
      immediate: true,
    },
    updateEld: {
      handler(val) {
        const displayStepOne = this.$route.query.eldProviders;
        if (val === true && !displayStepOne) {
          // this.$store.dispatch('onboardingPacket/getEldProviders');
          this.showConnectEldInModal = true;
        }
      },
      immediate: true,
    },
    initiallyShowConnectEldInModal: function (val) {
      this.showConnectEldInModal = val;
    },
  },
  async created() {
    if (!this.isLoading && !this.eldProviders?.length) {
      this.$store.dispatch('onboardingPacket/getEldProviders');
    }
  },
  methods: {
    handleSelectRadio(e, value) {
      if (e?.target?.name) {
        this.selectedItem = value;
        this.$refs['continuebtn'].$el.nextElementSibling.scrollIntoView({
          behavior: 'smooth',
        });
        setTimeout(
          function () {
            this.$refs['continuebtn'].$el.nextElementSibling.focus();
          }.bind(this),
          500
        );
      }
    },
    async handleExempt() {
      if (this.eldExempt?.id) {
        await this.$store.dispatch(
          'onboardingPacket/createCarrierEldProvider',
          this.eldExempt?.id
        );
      }
      this.showConnectEldInModal = true;
      // this.$router.push({
      //     name: "Carrier Connect ELD",
      //     params: {
      //     id: this.$route.params.id,
      //     }
      // });
    },
    async handleSubmit() {
      let res = null;
      if (this.selectedItem) {
        res = await this.$store.dispatch(
          'onboardingPacket/createCarrierEldProvider',
          this.selectedItem
        );
      }
      if (res && res?.data?.id) {
        this.showConnectEldInModal = true;
      }
    },
    async handleCloseModal() {
      const dialog = document.getElementById('dialog');
      this.$store.commit('myLoadsStore/setShowConnectEldDialog', false);
      dialog.close();
    },
  },
};
</script>
<!-- <style>
.eld-grid-area {
    margin-bottom: 187px;
}
@media (min-width: 640px) {
    .eld-grid-area {
        margin-bottom: 0;
    }
}
</style> -->
